type IconName =
  | "search"
  | "grid"
  | "home"
  | "car"
  | "sprout"
  | "sprout-simple"
  | "shirt"
  | "leaf"
  | "phone"
  | "book"
  | "apple"
  | "star"
  | "briefcase"
  | "heart"
  | "eye"
  | "mail"
  | "message"
  | "bell"
  | "camera"
  | "settings"
  | "sliders"
  | "pencil"
  | "share"
  | "trash"
  | "logout"
  | "user"
  | "ai-spark"
  | "ethical-shield"
  | "ethical-leaf"
  | "ethical-users"
  | "ethical-eco"
  | "no-egg"
  | "no-bug";

const imageIcons: Partial<Record<IconName, string>> = {
  "ethical-shield": "ethical-shield.png",
  "ethical-leaf": "ethical-leaf.png",
  "ethical-users": "ethical-users.png",
  "ethical-eco": "ethical-eco.png",
  "no-egg": "ethical-no-egg.png",
  "no-bug": "ethical-no-bug.png",
  "sprout-simple": "ethical-vegan.png"
};

type SvgIconName = Exclude<IconName, keyof typeof imageIcons>;

const icons: Record<SvgIconName, string> = {
  search: '<path d="m20 20-4.5-4.5"/><circle cx="11" cy="11" r="6.5"/>',
  grid: '<rect x="4" y="3.5" width="16" height="17" rx="2"/><path d="M8 7h4v4H8zM15 8h2M15 11h2M8 15h8"/>',
  home: '<path d="M4 11 12 4l8 7v9h-5v-6H9v6H4z"/>',
  car: '<path d="m5 12 2-5h10l2 5M5 12h14v6H5zM7 18v2m10-2v2M7 15h.1M17 15h.1"/>',
  sprout: '<path d="M12 20V9m0 0C9 5 6 4 3 5c1 4 4 6 9 4Zm0 0c3-4 6-5 9-4-1 4-4 6-9 4Z"/>',
  "sprout-simple": '<path d="M12 20v-7"/><path d="M12 14c-1.5-4.1-4.8-5.8-8.6-5.1.7 4.1 3.6 6.1 8.6 5.1Z"/><path d="M12 12.8c1.4-4.6 4.8-6.8 8.8-6.2-.5 4.3-3.6 6.8-8.8 6.2Z"/>',
  shirt: '<path d="m8 4 4 3 4-3 4 3-2 4-2-1v10H8V10l-2 1-2-4z"/>',
  leaf: '<path d="M20 4C11 4 5 9 5 17c6 0 13-3 15-13ZM5 17c3-4 6-6 10-8"/>',
  phone: '<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M11 17h2"/>',
  book: '<path d="M5 5h6a3 3 0 0 1 3 3v12a3 3 0 0 0-3-3H5zM19 5h-5a3 3 0 0 0-3 3v12a3 3 0 0 1 3-3h5z"/>',
  apple: '<path d="M12 8c4-3 9 0 7 6-1 5-4 7-7 5-3 2-6 0-7-5-2-6 3-9 7-6Zm0 0c0-3 2-4 4-5"/>',
  star: '<path d="m12 3 3 6 6 1-4.5 4.5 1 6L12 17l-5.5 3.5 1-6L3 10l6-1z"/>',
  briefcase: '<path d="M8 7V5h8v2m-12 3h16v10H4zM4 12h16"/>',
  heart: '<path d="M20.5 8.5c0 5.2-8.5 10.5-8.5 10.5S3.5 13.7 3.5 8.5A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 8.5 2.5Z"/>',
  eye: '<path d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.7"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4.5 7 7.5 6 7.5-6"/>',
  message: '<path d="M5 5h14v10H8l-4 4V6a1 1 0 0 1 1-1Z"/>',
  bell: '<path d="M10.3 20.5a2 2 0 0 0 3.4 0"/><path d="M5 15.8c1.1-1.2 1.6-2.8 1.6-5.3a5.4 5.4 0 0 1 10.8 0c0 2.5.5 4.1 1.6 5.3"/><path d="M4.2 16.8h15.6"/>',
  camera: '<path d="M5 7h3l1.4-2h5.2L16 7h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"/><path d="M12 10a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"/>',
  settings: '<path d="M9.7 4.1a2.35 2.35 0 0 1 4.6 0 2.35 2.35 0 0 0 3.3 1.9 2.35 2.35 0 0 1 2.3 4 2.35 2.35 0 0 0 0 3.9 2.35 2.35 0 0 1-2.3 4 2.35 2.35 0 0 0-3.3 1.9 2.35 2.35 0 0 1-4.6 0 2.35 2.35 0 0 0-3.3-1.9 2.35 2.35 0 0 1-2.3-4 2.35 2.35 0 0 0 0-3.9 2.35 2.35 0 0 1 2.3-4 2.35 2.35 0 0 0 3.3-1.9Z"/><path d="M12 8.7a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Z"/>',
  sliders: '<path d="M4 7h7M15 7h5M4 17h5M13 17h7"/><path d="M11 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM9 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"/>',
  pencil: '<path d="M4 20h4l11-11a2.8 2.8 0 0 0-4-4L4 16v4Z"/><path d="m13.5 6.5 4 4"/>',
  share: '<circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="m8.2 10.8 7.6-4.5M8.2 13.2l7.6 4.5"/>',
  trash: '<path d="M4 7h16M9 7V4h6v3M6.5 7l.8 13h9.4l.8-13M10 11v5M14 11v5"/>',
  logout: '<path d="M10 5H5v14h5M14 8l4 4-4 4M8 12h10"/>',
  user: '<path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 21a8 8 0 0 1 16 0"/>',
  "ai-spark": '<defs><linearGradient id="aiSparkGradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#2587d8"/><stop offset="34%" stop-color="#2f8f7b"/><stop offset="62%" stop-color="#235f2e"/><stop offset="84%" stop-color="#6a3fb2"/><stop offset="100%" stop-color="#2587d8"/><animateTransform attributeName="gradientTransform" type="rotate" from="0 12 12" to="360 12 12" dur="6.4s" repeatCount="indefinite"/></linearGradient></defs><path d="M4.1 4.9h9.2M4.1 4.9v14.9h14.9v-7.5" stroke="url(#aiSparkGradient)" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/><text x="6.1" y="17" fill="url(#aiSparkGradient)" stroke="none" font-family="Inter, Arial, sans-serif" font-size="10.8" font-weight="850" letter-spacing="-.45">AI</text><path d="M18.7 2.5l1.22 3.05 3.05 1.22-3.05 1.22-1.22 3.05-1.22-3.05-3.05-1.22 3.05-1.22zM21.1 1.6l.62 1.55 1.55.62-1.55.62-.62 1.55-.62-1.55-1.55-.62 1.55-.62z" fill="url(#aiSparkGradient)" stroke="none"/>'
};

export function Icon({ name }: { name: IconName }) {
  const imageIcon = imageIcons[name];
  if (imageIcon) {
    return <span className="ui-icon ui-icon-image"><img src={`/assets/icons/${imageIcon}`} alt="" /></span>;
  }
  return <span className="ui-icon" dangerouslySetInnerHTML={{ __html: `<svg viewBox="0 0 24 24">${icons[name as SvgIconName]}</svg>` }} />;
}

export function categoryIcon(slug: string): IconName {
  if (slug === "real-estate") return "home";
  if (slug === "transport" || slug === "parts-accessories") return "car";
  if (slug === "home-garden") return "sprout";
  if (slug === "personal-items" || slug === "kids") return "shirt";
  if (slug === "beauty-health" || slug === "spiritual-items" || slug === "handmade") return "leaf";
  if (slug === "electronics") return "phone";
  if (slug === "hobby" || slug === "literature") return "book";
  if (slug === "food") return "apple";
  if (slug === "services") return "star";
  if (slug === "jobs") return "briefcase";
  return "leaf";
}
